import { getWeightedAverage } from '@mentimeter/visualizations-react/visualizations/scales/helpers';
import type { ScalesResultT } from '@mentimeter/visualizations';
import type { Question } from '@mentimeter/http-clients';

interface ScreenReaderResultsProps {
  results: ScalesResultT[];
  range: Question['range'];
  dimensionLabels: { min: string; max: string };
  shouldHideResults: boolean;
}

export const ScreenReaderResults = ({
  results,
  dimensionLabels,
  range,
  shouldHideResults,
}: ScreenReaderResultsProps) => {
  if (shouldHideResults) {
    return <span>Results are currently hidden.</span>;
  }

  return (
    <table lang="en">
      <caption>Results</caption>
      <thead>
        <tr>
          <th>Options</th>
          <th>
            {`Average value on a range from ${range.min} (${dimensionLabels.min}) to ${range.max} (${dimensionLabels.max})`}
          </th>
        </tr>
      </thead>
      <tbody>
        {results.map((result) => {
          const hasOnlyZeros = Object.values(result.score).every(
            (score) => score === 0,
          );

          if (hasOnlyZeros) {
            return (
              <tr key={result.id}>
                <td>{result.label}</td>
                <td>There are no results yet</td>
              </tr>
            );
          }

          const average = getWeightedAverage(result.score);
          return (
            <tr key={result.id}>
              <td>{result.label}</td>
              <td>{average.toFixed(1)}</td>
            </tr>
          );
        })}
      </tbody>
    </table>
  );
};
